import moment from "moment";
import { useEffect, useState } from "react";
import { API_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import calendar from "../../img/calendar.png";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import { FiArrowRight, FiDownload, FiLock, FiCalendar, FiClock, FiZap } from "react-icons/fi";
import { FaStar, FaInstagram, FaYoutube, FaGlobe, FaLinkedin, FaFacebook } from "react-icons/fa";

import "./ServiceCardThemeV16.css";

moment.locale("en");

// Calendar Component
function MonthGridCalendar({ slots, packageDays, selectedValue, onSelect }) {
  const today = moment().locale("en");
  const [viewMonth, setViewMonth] = useState(today.clone().startOf("month"));

  const availableSet = new Set((slots || []).filter((s) => s.available).map((s) => s.value));
  const slotMap = {};
  (slots || []).forEach((s) => { slotMap[s.value] = s; });

  const goMonth = (dir) => setViewMonth((prev) => prev.clone().locale("en").add(dir, "month").startOf("month"));

  const vmEn = viewMonth.clone().locale("en");
  const startDay = vmEn.clone().startOf("month").day();
  const daysInMonth = vmEn.daysInMonth();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const isPrevDisabled = viewMonth.clone().locale("en").isSameOrBefore(today.clone().startOf("month"));

  return (
    <div>
      <div className="monthNavRow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <button type="button" onClick={() => goMonth(-1)} disabled={isPrevDisabled} style={{ background: 'none', border: 'none', cursor: isPrevDisabled ? 'not-allowed' : 'pointer', fontSize: '18px', color: 'var(--v16-muted)' }}>‹</button>
        <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--v16-dark)' }}>{vmEn.format("MMMM YYYY")}</h4>
        <button type="button" onClick={() => goMonth(1)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: 'var(--v16-muted)' }}>›</button>
      </div>
      <table className="monthGridCalendar" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
        <thead>
          <tr>{DOW.map((d) => (<th key={d} style={{ padding: '8px 0', fontSize: '12px', opacity: 0.7 }}>{d}</th>))}</tr>
        </thead>
        <tbody>
          {weeks.map((week, wi) => (
            <tr key={wi}>
              {week.map((day, di) => {
                if (!day) return <td key={di}><div style={{ padding: '8px' }}></div></td>;
                const dateVal = vmEn.clone().date(day).format("YYYY/MM/DD");
                const isPast = vmEn.clone().date(day).isBefore(today, "day");
                const dayMatches = packageDays.length === 0 || packageDays.includes(moment(dateVal, "YYYY/MM/DD").locale("en").format("ddd").toUpperCase());
                const isAvail = availableSet.has(dateVal) && !isPast && dayMatches;
                const isSelected = selectedValue === dateVal;

                let btnClass = "gridDayBtn ";
                if (isSelected) btnClass += "gridSelected";
                else if (isAvail) btnClass += "gridAvailable";

                return (
                  <td key={di} style={{ padding: '4px' }}>
                    <button
                      type="button"
                      className={btnClass}
                      style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', cursor: isAvail ? 'pointer' : 'not-allowed', opacity: isAvail || isSelected ? 1 : 0.3 }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isAvail) return;
                        const slotObj = slotMap[dateVal];
                        if (slotObj) onSelect(slotObj);
                      }}
                    >
                      {day}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Time Panel Component
function TimeSidePanel({ hasDateSelected, slots, selectedSlot, onSelect, isDisabledFn }) {
  return (
    <div className="timeSide">
      <div className="v16-section-eyebrow" style={{ marginBottom: '16px' }}>
        <FiClock size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
        Select Time
      </div>
      {!hasDateSelected ? (
        <div style={{ opacity: 0.5, fontSize: '13px', fontWeight: 600 }}>Pick a date to see times</div>
      ) : (
        <div className="v16-twoColSlots">
          {slots.length > 0 ? (
            slots.map((item, i) => {
              const fromStr = item.from ?? "";
              const toStr = item.to ?? "";
              const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
              const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
              const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
              const isSelected = selectedSlot?.from === fromStr && selectedSlot?.to === toStr;
              const isDisabled = isDisabledFn ? isDisabledFn(item) : false;

              return (
                <button
                  type="button"
                  key={i}
                  className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                  style={{ padding: '12px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                  onClick={(e) => { e.preventDefault(); if (!isDisabled) onSelect(item); }}
                >
                  {displayFrom} – {displayTo}
                </button>
              );
            })
          ) : (
            <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 600 }}>No slots available</p>
          )}
        </div>
      )}
    </div>
  );
}

// Main Component
const ServiceCardThemeV16 = ({
  data,
  selectService,
  isPreview,
  uploadDetails,
  updateState,
  confirmDetails,
  recaptcha,
  viewAvailableSlot,
  slugSelected,
  onResourceClick,
}) => {

  const eventData = data.eventData || data.eventDetails || {};
  const userDetails = data.userDetails || {};
  const resourceList = data.resource || data.resourceList || [];

  const businessLogo = isPreview
    ? eventData.businessLogo
    : eventData.businessLogo ? `${API_URL}auth/image/${eventData.businessLogo}` : calendar;

  const businessName = eventData.businessName || userDetails.userName || "Viraj Kulkarni";
  const defaultTitle = "GET THE IMPORTANT THINGS DONE.";

  // NEW UI: hero title now prefers sliderTextOne, falling back to serviceName then the default
  const displayTitle = eventData.sliderTextOne || eventData.serviceName || defaultTitle;
  // NEW UI: hero eyebrow now prefers sliderTextTwo (was sliderTextOne, which now feeds the title above)
  const displayEyebrow = eventData.sliderTextTwo || eventData.sliderTextOne || "MAKE THE WORK RUN CLEANER";
  // NEW UI: header tagline is now dynamic based on the service name
  const headerTagline = eventData.serviceName?.toUpperCase() || "OPERATOR";

  const rawReviews = data.reviewList || [];
  const dummyReviews = [
    { name: "Rajeev B.", source: "Founder review", suggestion: "Viraj found the small operational leaks draining every week.", satisfaction: 5 },
    { name: "M. Srinivasan", source: "Featured review", suggestion: "A decision we could finally stand behind.", satisfaction: 5 },
    { name: "Sonal G.", source: "Google", suggestion: "The workshop turned a vague handoff problem into a working system.", satisfaction: 5 }
  ];
  const reviews = rawReviews.length > 0 ? rawReviews : dummyReviews;
  const avgRating = eventData.ratings ?? "4.9/5";

  const dummyServices = [
    { serviceName: "Operator call", duration: 60, amount: 3200, appointmentName: "INDIVIDUAL CONSULTATION", description: "A focused working conversation on one operational or strategic problem.", timeLabel: "Online" },
    { serviceName: "Workflow reset", duration: 90, amount: 5500, appointmentName: "TEAM WORKSHOP", description: "A facilitated session that gets the right people working on the same system.", timeLabel: "Remote workshop" },
    { serviceName: "Embedded sprint", duration: 0, amount: 28000, appointmentName: "INDIVIDUAL CONSULTATION", description: "A practical session to turn a broad challenge into a plan.", timeLabel: "2 weeks · Limited availability" }
  ];
  const rawServiceList = data.service || data.serviceList || [];
  const serviceList = rawServiceList.length > 0 ? rawServiceList : dummyServices;

  const [chosenService, setChosenService] = useState(null);
  const [isPackageSelected, setIsPackageSelected] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNoteOption, setSelectedNoteOption] = useState(""); // Track the dropdown selection
  const isMobile = window.screen.width < 768;

  useEffect(() => {
    if (!slugSelected || !serviceList.length) return;
    const index = serviceList.findIndex((s) => s.slug === slugSelected || String(s.id) === String(slugSelected));
    if (index !== -1) handleBookClick(serviceList[index], index);
  }, [slugSelected, serviceList]);

  // FIX 2: close the modal automatically once a booking completes.
  useEffect(() => {
    if (data.bookingSuccess) {
      setIsModalOpen(false);
    }
  }, [data.bookingSuccess]);

  const safeParse = (value) => {
    try {
      if (!value) return [];
      const p = JSON.parse(value);
      return typeof p === "string" ? JSON.parse(p) : p;
    } catch (e) { return []; }
  };

  const packageDays = safeParse(isPackageSelected?.packageDays);
  const timeSlots = safeParse(isPackageSelected?.timeSlots) || [];

  const getAllSlots = () => {
    if (!data.availableSlot?.length) return [];
    return data.availableSlot.filter((item) => {
      if (Object.keys(data?.activeIndexData || {}).length > 0) {
        const isToday = moment(data.activeIndexData.value, "YYYY/MM/DD");
        if (isToday.isSame(moment(), "day")) {
          const curTime = moment(new Date(), "HH:mm");
          const fromTime = moment(item.from, "HH:mm");
          return fromTime.isSameOrAfter(curTime);
        }
      }
      return true;
    });
  };

  const priceLabel = (svc) => (svc?.amount == 0 ? "Free" : `₹${svc?.amount}`);
  const selectedServiceObj = chosenService !== null ? serviceList[chosenService] : null;

  const handleBookClick = (item, ind) => {
    selectService(item);
    setChosenService(ind);
    setIsPackageSelected(item);
    updateState("bookingMode", "self");
    updateState("expertNote", "");
    updateState("bookingSuccess", false); // FIX 2: clear stale success flag
    setIsModalOpen(true);
  };

  const handleResourceCardClick = (res) => {
    if (isPreview) return;
    if (typeof onResourceClick === "function") onResourceClick(res);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    updateState("name", "");
    updateState("email", "");
    updateState("phoneNumber", "");
    updateState("description", "");
    updateState("detailsPage", false); // Reset back to step 1
    updateState("bookingSuccess", false); // FIX 2: reset success flag on manual close
    setSelectedNoteOption(""); // Reset dropdown selection

    if (recaptcha?.current) {
      recaptcha.current.reset();
    }
  };

  // V16 Step Indicator
  const renderStepper = (activeStep) => (
    <div className="v16-bkStepBar">
      <div className={`v16-bkStep ${activeStep === 1 ? "active" : activeStep > 1 ? "done" : ""}`}>
        <div className="v16-bkStepCircle">{activeStep > 1 ? "✓" : "1"}</div>
        <span>Choose option</span>
      </div>
      <div className={`v16-bkStepLine ${activeStep > 1 ? "done" : ""}`} />
      <div className={`v16-bkStep ${activeStep === 2 ? "active" : activeStep > 2 ? "done" : ""}`}>
        <div className="v16-bkStepCircle">{activeStep > 2 ? "✓" : "2"}</div>
        <span>Provide details</span>
      </div>
      <div className={`v16-bkStepLine ${activeStep > 2 ? "done" : ""}`} />
      <div className={`v16-bkStep ${activeStep === 3 ? "active" : ""}`}>
        <div className="v16-bkStepCircle">3</div>
        <span>Confirmation</span>
      </div>
    </div>
  );

  // Modal Booking Flow
  const renderBookingModal = () => {
    if (!isModalOpen || chosenService === null) return null;
    const isGroupPackage = ["group_package", "one_to_one_package"].includes(isPackageSelected?.appointmentName);

    return (
      <div className="v16-modal-overlay" onClick={closeModal}>
        <div className="v16-modal-content" onClick={(e) => e.stopPropagation()}>
          <button type="button" className="v16-modal-close" onClick={closeModal}>×</button>

          {data.detailsPage ? (
            <form onSubmit={(e) => { e.preventDefault(); uploadDetails(e); }} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {renderStepper(2)}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
                <h4 className="v16-section-title" style={{ margin: 0, fontSize: '24px' }}>Provide Details</h4>
                <button type="button" onClick={() => { recaptcha?.current?.reset(); updateState("detailsPage", false); }} className="v16-btn-outline" style={{ border: 'none' }}>
                  ← Back
                </button>
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', color: 'var(--v16-muted)' }}>Name *</label>
                <input className="input-text-input" value={data.name} type="text" placeholder="ENTER NAME" required onChange={(e) => updateState("name", e.target.value)} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', color: 'var(--v16-muted)' }}>Email *</label>
                <input className="input-text-input" value={data.email} type="email" placeholder="ENTER EMAIL" required onChange={(e) => updateState("email", e.target.value?.trim())} />
              </div>
               <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Phone Number *</label>
                <div style={{ marginTop: "4px" }}>
                  <PhoneInput
                    country={"in"}
                    containerClass="input-dark"
                    value={data.phoneNumber}
                    placeholder=""
                    countryCodeEditable={false}
                    onChange={(phone) => updateState("phoneNumber", phone)}
                    required
                  />
                </div>
              </div>
                  <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Notes for preparation *</label>
                <select 
                  className="input-text-input" 
                  value={selectedNoteOption}
                  required
                  onChange={(e) => {
                    setSelectedNoteOption(e.target.value);
                    if (e.target.value !== "Other") {
                      updateState("description", e.target.value);
                    } else {
                      updateState("description", "");
                    }
                  }}
                  style={{ marginBottom: selectedNoteOption === "Other" ? '12px' : '0' }}
                >
                  <option value="" disabled>Select an option</option>
                  <option value="I'm looking for general relaxation and mindfulness.">I'm looking for general relaxation and mindfulness.</option>
                  <option value="I'm dealing with specific tension/tightness and need relief.">I'm dealing with specific tension/tightness and need relief.</option>
                  <option value="I'm a beginner looking for a gentle introduction.">I'm a beginner looking for a gentle introduction.</option>
                  <option value="Other">Other (I will type my own notes)</option>
                </select>

                {selectedNoteOption === "Other" && (
                  <textarea 
                    className="input-text-input" 
                    value={data.description} 
                    required={selectedNoteOption === "Other"} 
                    placeholder="Please specify your requirements or notes here..."
                    onChange={(e) => updateState("description", e.target.value)} 
                    style={{ minHeight: '100px', resize: 'vertical' }} 
                  />
                )}
              </div>

              <div style={{ margin: "8px 0" }}>
                <ReCAPTCHA size={isMobile ? "compact" : "normal"} ref={recaptcha} sitekey={REACT_APP_SITE_KEY} />
              </div>

              <button type="submit" className="v16-btn-primary" onClick={() => confirmDetails()} style={{ alignSelf: 'flex-start' }}>
                <FiCalendar size={16} /> Book {selectedServiceObj?.serviceName} - {priceLabel(selectedServiceObj)} <FiArrowRight size={16} />
              </button>
            </form>
          ) : (
            <div>
              {renderStepper(1)}

              {!isGroupPackage && (
                <>
                  <div style={{ marginBottom: '32px', textAlign: 'center' }}>
                    <h2 className="v16-section-title" style={{ fontSize: '32px', marginBottom: '8px' }}>
                      Schedule your session
                    </h2>
                    <p style={{ opacity: 0.6, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', fontSize: '13px', color: 'var(--v16-dark)' }}>
                      Choose how you&apos;d like to book
                    </p>
                  </div>

                  <div className="v16-bkModeRow">
                    <div className={`v16-bkModeCard ${data.bookingMode === "self" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "self")}>
                      <div className="v16-bkModeRadio">{data.bookingMode === "self" && <div className="v16-bkModeRadioInner" />}</div>
                      <div className="v16-bkModeText">
                        <h5>I&apos;ll pick date & time</h5>
                        <p>Select from available slots</p>
                      </div>
                    </div>

                    <div className={`v16-bkModeCard ${data.bookingMode === "expert" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "expert")}>
                      <div className="v16-bkModeRadio">{data.bookingMode === "expert" && <div className="v16-bkModeRadioInner" />}</div>
                      <div className="v16-bkModeText">
                        <h5>Let the expert choose</h5>
                        <p>Share your preference and expert will schedule</p>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {data.bookingMode === "expert" && !isGroupPackage && (
                <div style={{ padding: '32px', background: '#fff', border: '1px solid var(--v16-border)', marginBottom: '32px' }}>
                  <label style={{ display: 'block', marginBottom: '16px', fontSize: '14px', fontWeight: 800, textTransform: 'uppercase', color: 'var(--v16-dark)' }}>Share your preference / availability</label>
                  <textarea
                    className="input-text-input"
                    placeholder="e.g. I'm available weekday evenings after 6 PM IST, prefer Thursday or Friday..."
                    value={data.expertNote || ""}
                    onChange={(e) => updateState("expertNote", e.target.value)}
                    style={{ minHeight: '120px', marginBottom: '16px' }}
                  />
                  <p style={{ fontSize: '13px', opacity: 0.7, fontWeight: 600 }}>The expert will review your preference and send you a confirmed slot via email.</p>
                </div>
              )}

              {(data.bookingMode === "self" || isGroupPackage) && (
                <div className="v16-calTimeSplit">
                  <div className="v16-calSide">
                    <div className="v16-section-eyebrow" style={{ marginBottom: '16px' }}>
                      <FiCalendar size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                      Select Date
                    </div>
                    <MonthGridCalendar
                      slots={data.slots}
                      packageDays={isGroupPackage ? packageDays : []}
                      selectedValue={data.activeIndexData?.value}
                      onSelect={(slotObj) => {
                        const idx = data.slots?.findIndex((s) => s.value === slotObj.value);
                        viewAvailableSlot(idx ?? 0, slotObj, slotObj.available);
                      }}
                    />
                  </div>

                  <div className="v16-timeSide">
                    {data.activeIndexData?.value && (
                      <div className="v16-tzChip">
                        <FiClock size={14} style={{ marginRight: '4px' }} /> {eventData.timeZone ? `Times in ${eventData.timeZone}` : "Times in IST"}
                      </div>
                    )}

                    {!data.activeIndexData?.value ? (
                      <div style={{ padding: '60px 20px', textAlign: 'center', opacity: 0.4, border: '1px solid var(--v16-border)', background: '#fff' }}>
                        <FiCalendar size={40} style={{ marginBottom: '16px' }} />
                        <p style={{ fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>No date selected<br /><span style={{ opacity: 0.7, fontWeight: 500, fontSize: '12px', textTransform: 'none' }}>Pick a date on the left</span></p>
                      </div>
                    ) : (
                      <div className="v16-twoColSlots">
                        {(isGroupPackage ? timeSlots : getAllSlots()).length > 0 ? (
                          (isGroupPackage ? timeSlots : getAllSlots()).map((item, i) => {
                            const fromStr = item.from ?? "";
                            const toStr = item.to ?? "";
                            const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
                            const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
                            const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
                            const isSelected = data.selectedSlot?.from === fromStr && data.selectedSlot?.to === toStr;
                            const isDisabled = item.slotAvailable === false;

                            return (
                              <button
                                type="button"
                                key={i}
                                className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                                style={{ padding: '14px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1, textTransform: 'uppercase', letterSpacing: '1px' }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!isDisabled) {
                                    updateState("slotActiveIndex", isGroupPackage ? i : getAllSlots().findIndex(s => s.from === item.from));
                                    updateState("selectedSlot", item);
                                  }
                                }}
                              >
                                {displayFrom} – {displayTo}
                              </button>
                            );
                          })
                        ) : (
                          <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 700, textTransform: 'uppercase', color: 'var(--v16-dark)' }}>No slots available</p>
                        )}
                      </div>
                    )}

                    {!isGroupPackage && data.activeIndexData?.value && (
                      <div style={{ display: 'flex', gap: '16px', padding: '24px', background: '#fff', border: '1px solid var(--v16-border)', marginTop: '24px' }}>
                        <FiZap size={20} color="var(--v16-dark)" style={{ flexShrink: 0 }} />
                        <div>
                          <h6 style={{ fontSize: '14px', fontWeight: 800, marginBottom: '8px', textTransform: 'uppercase', color: 'var(--v16-dark)' }}>Instant confirmation</h6>
                          <p style={{ fontSize: '13px', opacity: 0.7, lineHeight: 1.5, fontWeight: 500 }}>Your session will be confirmed immediately after booking.</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div style={{ marginTop: '48px', display: 'flex', justifyContent: 'center' }}>
                <button
                  type="button"
                  className="v16-btn-primary"
                  style={{ width: '100%', maxWidth: '400px', justifyContent: 'center' }}
                  onClick={() => isPreview ? () => {} : confirmDetails()}
                >
                  Continue to Details <FiArrowRight size={18} />
                </button>
              </div>

            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="v16-wrapper">
      <div className="v16-container">

        {/* Navigation */}
        <header className="v16-header">
          <div className="v16-logo-group">
            <span className="v16-logo-circle">
              {businessLogo && businessLogo !== calendar ? (
                <img src={businessLogo} alt="Logo" />
              ) : (
                "VK"
              )}
            </span>
            {/* NEW UI: tagline now driven by eventData.serviceName */}
            <span>{businessName.split(' ')[0].toUpperCase()} / {headerTagline}</span>
          </div>
          <div className="v16-header-tag">
            {eventData.specialisations?.split(',')[0] || "Independent operations partner"}
          </div>
        </header>

        {/* Hero Area */}
        <section className="v16-hero">
          <div className="v16-hero-content">
            {/* NEW UI: eyebrow now driven by sliderTextTwo */}
            <div className="v16-hero-eyebrow">{displayEyebrow}</div>
            <h1 className="v16-hero-title">
              {displayTitle.split('.').map((phrase, i) => <span key={i}>{phrase}{i < displayTitle.split('.').length - 1 ? '.' : ''}<br /></span>)}
            </h1>
            <div className="v16-hero-desc" dangerouslySetInnerHTML={{ __html: eventData.description || "Practical operating support for small teams with big moving parts." }} />
            <button
              type="button"
              className="v16-btn-primary"
              onClick={() =>
                document
                  .querySelector('#services-section')
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            >
              Book an operator call
            </button>
          </div>

          <div className="v16-hero-visual">
            {businessLogo && businessLogo !== calendar ? (
              <div className="v16-hero-image" style={{ backgroundImage: `url(${businessLogo})` }}></div>
            ) : (
              <div className="v16-hero-image" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=600')` }}></div>
            )}
          </div>
        </section>

        {/* Services Block (Dark Background) */}
        <div className="v16-services-wrapper" id="services-section">
          <div className="v16-services-grid">
            {serviceList.map((item, ind) => {
              return (
                <div key={ind} className="v16-service-card">
                  <div className="v16-service-index">
                    0{ind + 1} / {item.duration || 0} {item.duration === 0 ? "weeks" : "min"}
                  </div>
                  <div className="v16-service-name">{item.serviceName}</div>
                  <div className="v16-service-price">
                    {priceLabel(item)} {item.timeLabel ? `· ${item.timeLabel}` : ''}
                  </div>
                  <div className="v16-service-type">
                    {item.appointmentName?.replace(/_/g, ' ').toUpperCase() || "INDIVIDUAL CONSULTATION"}
                  </div>
                  <p className="v16-service-desc">{item.description}</p>
                  <button type="button" className="v16-btn-outline" onClick={() => handleBookClick(item, ind)}>
                    {item.btnText || "Book this session →"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Beige Wrapper for the rest of the content */}
        <div className="v16-bottom-wrapper">

          {/* Client Notes Box */}
          <section className="v16-notes-section">
            <div className="v16-notes-header">
              <div>
                <div className="v16-section-eyebrow">CLIENT NOTES</div>
                <h2 className="v16-section-title">What clients say about {businessName.split(' ')[0]}</h2>
              </div>
              <div style={{ fontSize: '13px', fontWeight: 800 }}>★★★★★ · {avgRating}</div>
            </div>

            <div className="v16-reviews-grid">
              {reviews.slice(0, 3).map((rev, idx) => (
                <div className="v16-review-card" key={idx}>
                  <div className="v16-review-stars">
                    {Array.from({ length: Math.round(rev.satisfaction || 5) }).map((_, i) => (
                      <FaStar key={i} size={14} color="var(--v16-dark)" />
                    ))}
                  </div>
                  <div className="v16-review-text">
                    “{rev.suggestion && rev.suggestion !== "Not given" ? rev.suggestion : "Highly recommended session."}”
                  </div>
                  <div className="v16-review-author">
                    {rev.name} · {rev.source || "Google"}
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Ready-Made Resources Section */}
          {resourceList.length > 0 && (
            <section className="v16-resources-section" id="resources-section">
              <div className="v16-notes-header" style={{ marginBottom: '32px' }}>
                <div>
                  <div className="v16-section-eyebrow">DIGITAL RESOURCES</div>
                  <h2 className="v16-section-title">Get instant access</h2>
                </div>
              </div>
              <div className="v16-resources-grid">
                {resourceList.map((res, ind) => {
                  const isResourceFree = Number(res.amount) === 0;
                  const fileCount = res.resourceFiles?.length || 0;

                  return (
                    <div key={res.id} className="v16-resource-card" onClick={() => handleResourceCardClick(res)} style={{ cursor: 'pointer' }}>
                      <div className="v16-section-eyebrow" style={{ marginBottom: '16px' }}>
                        RESOURCE {ind + 1} {fileCount > 0 && `· ${fileCount} FILE${fileCount !== 1 ? 'S' : ''}`}
                      </div>
                      <h3 style={{ fontSize: '20px', fontWeight: 800, marginBottom: '8px' }}>{res.serviceName}</h3>
                      <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '16px' }}>
                        {isResourceFree ? "Free" : `₹${res.amount}`}
                      </div>
                      <p className="v16-review-text" style={{ fontSize: '13px', opacity: 0.8, flex: 1, marginBottom: '24px' }}>{res.description}</p>
                      <button
                        type="button"
                        className="v16-btn-outline"
                        style={{ marginTop: 'auto', width: 'fit-content' }}
                        onClick={(e) => { e.stopPropagation(); handleResourceCardClick(res); }}
                      >
                        {isResourceFree ? (
                          <>Download <FiDownload size={14} /></>
                        ) : (
                          <>Purchase <FiLock size={12} /></>
                        )}
                      </button>
                    </div>
                  );
                })}
              </div>
            </section>
          )}

          {/* About Provider */}
          <section className="v16-about-section">
            <div className="v16-about-inner">
              <div className="v16-section-eyebrow">MEET YOUR PROVIDER</div>
              <h3>{userDetails.userName || businessName}</h3>
              <p>
                {userDetails.profession?.professionName || "Viraj is an independent operations partner for teams that need their work to run more cleanly."}
              </p>

              {/* Render Social Media Accounts */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '20px', marginBottom: '32px' }}>
                {userDetails.youtube && (
                  <a href={userDetails.youtube} target="_blank" rel="noreferrer" style={{ color: 'var(--v16-dark)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                    <FaYoutube size={16} /> YouTube
                  </a>
                )}
                {userDetails.instagram && (
                  <a href={userDetails.instagram} target="_blank" rel="noreferrer" style={{ color: 'var(--v16-dark)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                    <FaInstagram size={16} /> Instagram
                  </a>
                )}
                {userDetails.personalWebsite && (
                  <a href={userDetails.personalWebsite} target="_blank" rel="noreferrer" style={{ color: 'var(--v16-dark)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                    <FaGlobe size={16} /> Website
                  </a>
                )}
                {userDetails.faceBook && (
                  <a href={userDetails.faceBook} target="_blank" rel="noreferrer" style={{ color: 'var(--v16-dark)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                    <FaFacebook size={16} /> Facebook
                  </a>
                )}
                {userDetails.linkedIn && (
                  <a href={userDetails.linkedIn} target="_blank" rel="noreferrer" style={{ color: 'var(--v16-dark)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                    <FaLinkedin size={16} /> LinkedIn
                  </a>
                )}
              </div>

              {eventData.specialisations && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxWidth: '500px', marginTop: '24px' }}>
                  {eventData.specialisations.split(',').map((spec, i) => (
                    <span key={i} style={{ border: '1px solid var(--v16-border)', padding: '6px 12px', fontSize: '11px', fontWeight: 800, textTransform: 'uppercase', color: 'var(--v16-muted)' }}>{spec.trim()}</span>
                  ))}
                </div>
              )}

              <div style={{ marginTop: '64px' }}>
                <svg width="120" height="30" viewBox="0 0 120 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.5 5 C10 12 15 20 18 20 C18 10 15 5 12.5 5 Z" fill="#e91e63" />
                  <path d="M22 5 C24.5 12 19 20 16 20 C16 10 19 5 22 5 Z" fill="#e91e63" opacity="0.8" />
                  <text x="32" y="21" fontFamily="Inter" fontWeight="800" fontSize="18" fill="var(--v16-dark)">Yuukke</text>
                </svg>
              </div>
            </div>
          </section>

        </div>

        {/* Render Booking Modal */}
        {renderBookingModal()}
      </div>
    </div>
  );
};

export default ServiceCardThemeV16;